import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
} from '@angular/core';

import { CellComponent, CellContext, GridData } from '@grid/models';

@Component({
  selector: 'app-time-edit',
  templateUrl: './time-edit.component.html',
  styleUrls: ['./time-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeEditComponent implements CellComponent<GridData> {
  @Input({ required: true }) context!: CellContext<GridData>;

  value!: string | null;
  isDirty = false;

  @HostListener('keydown.shift.+', ['$event'])
  stopEventPropagation(event: KeyboardEvent): void {
    event.stopPropagation();
  }

  onEndEdit(): void {
    if (!this.isDirty) {
      return;
    }

    const initialValue =
      this.context.data[this.context.column.columnDef] ?? null;

    if (initialValue !== this.value) {
      this.context.data[this.context.column.columnDef] = this.value;
      this.context.cell.actions.onEdited();
    }
  }

  onChange($event: any): void {
    this.value = $event as string;
    this.isDirty = true;
  }
}
